import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '@tokens/api-url.token';
import { IS_API_REQUEST } from '@tokens/api-request.token';
import { joinUrls } from '@utils/join-urls';

@Injectable()
export class UrlInterceptor implements HttpInterceptor {
  private apiUrl = inject(API_URL);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.context.get(IS_API_REQUEST)) {
      return next.handle(req);
    }

    return next.handle(req.clone({ url: joinUrls(this.apiUrl, req.url) }));
  }
}
